"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customer = exports.Gender = exports.PatientType = exports.Channel = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const enums_1 = require("../../common/enums");
Object.defineProperty(exports, "Channel", { enumerable: true, get: function () { return enums_1.Channel; } });
const address_entity_1 = require("../customers/address.entity");
const order_entity_1 = require("../orders/order.entity");
const medical_doc_entity_1 = require("../medical-history/medical-doc.entity");
const appointment_entity_1 = require("../consultation/appointment.entity");
const service_ticket_entity_1 = require("../tickets/service-ticket.entity");
const feedback_entity_1 = require("../feedback/feedback.entity");
const interaction_log_entity_1 = require("./interaction-log.entity");
var PatientType;
(function (PatientType) {
    PatientType["NEW"] = "new";
    PatientType["REPEAT"] = "repeat";
})(PatientType || (exports.PatientType = PatientType = {}));
var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
    Gender["OTHER"] = "other";
})(Gender || (exports.Gender = Gender = {}));
let Customer = class Customer {
};
exports.Customer = Customer;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Customer.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 20, unique: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "patientId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 120 }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({ length: 15 }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "phone", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 15, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "altPhone", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 150, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "email", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'date', nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Customer.prototype, "dob", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: Gender, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "gender", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: PatientType, default: PatientType.NEW }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "patientType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: enums_1.Channel, default: enums_1.Channel.INBOUND_CALL }),
    tslib_1.__metadata("design:type", typeof (_b = typeof enums_1.Channel !== "undefined" && enums_1.Channel) === "function" ? _b : Object)
], Customer.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "knownConditions", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "otherConditions", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "knownAllergies", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "currentMedicines", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 5, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Customer.prototype, "bloodGroup", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], Customer.prototype, "isActive", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => address_entity_1.Address, (a) => a.customer, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "addresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => order_entity_1.Order, (o) => o.customer),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "orders", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => medical_doc_entity_1.MedicalDoc, (d) => d.customer),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "medicalDocs", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => appointment_entity_1.Appointment, (a) => a.customer),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "appointments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => service_ticket_entity_1.ServiceTicket, (t) => t.customer),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "tickets", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => feedback_entity_1.Feedback, (f) => f.customer),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "feedbacks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => interaction_log_entity_1.InteractionLog, (l) => l.customer),
    tslib_1.__metadata("design:type", Array)
], Customer.prototype, "interactionLogs", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Customer.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Customer.prototype, "updatedAt", void 0);
exports.Customer = Customer = tslib_1.__decorate([
    (0, typeorm_1.Entity)('customers')
], Customer);
